export class InlineArrayHeaderContainer {
  arrayItem: any;
  headlineFields: Array<any>;
  labels: Array<any>;
  timeOutId;
  values: object;
}
